import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {UsersService} from '../../users/service/users.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {Router} from '@angular/router';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort, Sort} from '@angular/material/sort';
import {TerminationFeeService} from './service-termination-fee/termination-fee.service';
import {TerminationFeeModel} from '../../../models/TerminationFeeModel';
import {ProviderModel} from '../../../models/ProviderModel';

@Component({
  selector: 'app-termination-fee',
  templateUrl: './termination-fee.component.html',
  styleUrls: ['./termination-fee.component.scss']
})
export class TerminationFeeComponent extends BaseGeneralComponent implements OnInit, OnChanges, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isContractSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  offset: Offset;
  filter: TerminationFeeModel;
  numAnnoMeseData: any;
  contractTypeData: any;
  showNewEditDelete: boolean;
  showFilter: boolean;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;
  @Input() inServiceChanges?: boolean;
  @Input() reportSection?: boolean;

  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private terminationFeeService: TerminationFeeService,
              private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private userService: UsersService,
              private loaderService: LoaderService,
              private dialog: MatDialog,
              private router: Router) {
    super();
    this.loaderService.display(true);
    this.showActions = true;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.filter = new TerminationFeeModel();
    this.sectionId = this.SECTIONS.CONTRACTUAL_DATA;
  }

  ngOnInit() {
    this.isContractSection = this.returnIsContractSection(this.router.url);
    this.showNewEditDelete = !this.checkRole();
    this.showFilter = false;
    this.selectedRowIndex = this.idSelected;

    if (this.showActions === true) {
      this.displayedColumns = [
        'regionDesc', 'contractTypeDesc', 'localCustomerDesc',
        'resourceUnitCod', 'currencyDesc', 'terminationFee', 'actions'];
    } else {
      this.displayedColumns = [
        'regionDesc', 'contractTypeDesc', 'localCustomerDesc',
        'resourceUnitCod', 'currencyDesc', 'terminationFee'];
    }

    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.TERMINATION_FEE_OFFSET);
    this.getSessionStorageFilter();
    this.init();
  }

  ngOnChanges() {
  }

  init() {
     this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filter).subscribe(
      (resultContractType: any) => {
        this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
          (resultYearMonth: any) => {
            const providerDefault = this.filter.provider;
            this.numAnnoMeseData = this.filterFromDxc(providerDefault, resultYearMonth);

            if (!this.filter.numAnnoMese || !BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
                const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
                this.filter.numAnnoMese = numAnnoMese;
            }

            if (!this.reportSection) {
              this.showFilter = false;
              this.getDataPage(this.offset, this.filter);
            } else {
              this.showFilter = true;
            }
            this.loaderService.display(false);
          }, error => {
            console.log(error);
            this.loaderService.display(false);
          });
      });

  }

  getDataPage(offset: Offset, filter: TerminationFeeModel) {
    this.getPageSubscribe = this.terminationFeeService.getPage(offset, filter)
      .subscribe(
        (rFinal: any) => {
          this.dataSource = rFinal.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = rFinal.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const terminationFee = this.dataSource.find(data => data.id === id) as TerminationFeeModel, list: GenericArray[] = [
        {id: 'Month', value: this.toCustomStringAnnoMese(terminationFee.numAnnoMese)},
        {id: 'Provider Cod', value: this.toCustomString(terminationFee.provider.cod)},
        {id: 'Provider Description', value: this.toCustomString(terminationFee.provider.description)},
        {id: 'Region Cod', value: this.toCustomString(terminationFee.region.cod)},
        {id: 'Region Description', value: this.toCustomString(terminationFee.region.description)},
        {id: 'Contract Type Cod', value: this.toCustomString(terminationFee.contractType.cod)},
        {id: 'Contract Type Description', value: this.toCustomString(terminationFee.contractType.description)},
        {id: 'Local Customer Cod', value: this.toCustomString(terminationFee.localCustomer.cod)},
        {id: 'Local Customer Description', value: this.toCustomString(terminationFee.localCustomer.description)},
        {id: 'Resource Unit Cod', value: this.toCustomString(terminationFee.serviceVariant.cod)},
        {id: 'Resource Unit Description', value: this.toCustomString(terminationFee.serviceVariant.cod)},
        {id: 'Currency Cod', value: this.toCustomString(terminationFee.currency.cod)},
        {id: 'Currency Description', value: this.toCustomString(terminationFee.currency.description)},
        {id: 'Termination Fee', value: this.toCustomString(terminationFee.terminationFee)}
      ],
      dialogRef = this.dialog.open(DialogDetailComponent, {
        width: '40%',
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.TERMINATION_FEE_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  /*deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.loaderService.display(true);
      this.deleteElementSubscribe = this.terminationFeeService.softDelete(id)
        .subscribe(
          (result: boolean) => {
            if (result) {
              toastr.success('Termination Fee was deleted with success', 'Success');
              this.getDataPage(this.offset, this.filter);
            } else {
              toastr.warning('Termination Fee cannot be deleted', 'Warning');
              this.loaderService.display(false);
            }
          }, error =>  {
            this.loaderService.display(false);
            toastr.error('Termination Fee with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }*/

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }
    this.loaderService.display(false);
  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

/*
*   getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DISCOUNT_FILTER));
    this.filter = filter_ ? filter_ : new TerminationFeeModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
  }*/
  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.TERMINATION_FEE_FILTER));
    this.filter = filter_ ? filter_ : new TerminationFeeModel();
  }
}
